import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/components/layout/page-header';
import { DiscountsTab } from './discounts-tab';

/**
 * POS discounts — what a cashier can apply at the till.
 *
 * Marketing's page. The usage report that used to be a tab here now lives
 * under Finance, because `GetDiscountsOnOrdersReportAsync` accepts Finance,
 * StoreAdmin and SuperAdmin and **not** Marketing — so the tab was showing the
 * people who maintain these discounts a report the API would refuse them, and
 * hiding it from the finance staff it was written for.
 */
export function PosDiscountsPage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <PageHeader
        title={t('posDiscounts.title')}
        description={t('posDiscounts.subtitle')}
      />
      <DiscountsTab />
    </div>
  );
}
